import { Fingerprint, History } from 'lucide-react'
import { FadeIn } from '../../ui/FadeIn'
import { GlassCard } from '../../ui/GlassCard'
import { useLanguage } from '../../../contexts/LanguageContext'

export function UserHistoryModule() {
  const { t } = useLanguage()

  const features = [
    t('product.user.audit'),
    t('product.user.roles'),
    t('product.user.visibility'),
  ]

  return (
    <FadeIn className="h-full">
      <GlassCard className="h-full">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-sm font-semibold tracking-tight">{t('product.user.title')}</div>
            <div className="mt-1 text-xs text-white/65">
              {t('product.user.desc')}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <Fingerprint className="size-5 text-nexus-cyan" />
            </span>
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <History className="size-5 text-nexus-blue" />
            </span>
          </div>
        </div>

        <div className="mt-5 space-y-2 text-sm text-white/70">
          {features.map((feature, index) => (
            <div key={index} className="rounded-xl border border-white/10 bg-white/6 px-3 py-2">
              {feature}
            </div>
          ))}
        </div>
      </GlassCard>
    </FadeIn>
  )
}


